import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  BadgeComponent,
  CalloutComponent,
  IconComponent,
} from '@rivet-health/design-system';
import { MENU_CONTEXT_TOKEN } from './menu-context';
import { MenuItemComponent } from './menu-item.component';

/**
 * @deprecated
 */
export enum MenuAnchor {
  LEFT,
  RIGHT,
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: MENU_CONTEXT_TOKEN,
      useExisting: MenuComponent,
    },
  ],
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  @HostBinding('class.small')
  @Input()
  small: boolean = false;

  @HostBinding('class.light')
  @Input()
  light: boolean = false;

  @Input()
  showCaret: boolean = false;

  @Input()
  showTooltip: boolean = true;

  @Input()
  tooltip: string = 'Options';

  @Input()
  icon: IconComponent.Name = 'MoreVertical';

  @Input()
  text: string | null = null;

  @Input()
  disabled: boolean = false;

  @Input()
  preferredPosition: CalloutComponent.AnchoredPosition = 'bottom-left';

  @Input()
  badgeText: string | null = null;

  @Input()
  badgeType: BadgeComponent.Variant = 'brand';

  /*
   * @deprecated Unused
   */
  @Input() anchor: any;

  @ContentChildren(MenuItemComponent, { descendants: true })
  menuItemComponents: QueryList<MenuItemComponent>;

  @ContentChild(TemplateRef, { static: false })
  menuItemTemplate: TemplateRef<{}>;

  @ContentChild(TemplateRef, { static: false })
  menuItemLightTemplate: TemplateRef<{}>;

  showMenu: boolean = false;

  onClose = new EventEmitter<boolean>();

  @Output() onOpen = new EventEmitter();

  @ViewChild('trigger', { read: ElementRef })
  trggr: ElementRef;

  openMenu() {
    this.onOpen.emit();
    this.showMenu = true;
    this.cdr.detectChanges();
  }

  closeMenu(focus?: boolean) {
    this.showMenu = false;
    this.cdr.detectChanges();
    this.onClose.emit(focus || false);
    this.trggr.nativeElement.blur(); // prevent tooltip from showing after close
  }

  toggleMenu() {
    if (this.showMenu) {
      this.closeMenu(true);
    } else {
      this.openMenu();
    }
  }

  keydown(key: string) {
    switch (key) {
      case 'ArrowDown':
      case 'Down':
        this.focusNextOption();
        break;
      case 'ArrowUp':
      case 'Up':
        this.focusPreviousOption();
        break;
    }
  }

  focusNextOption() {
    this.focusOption(1);
  }

  focusPreviousOption() {
    this.focusOption(-1);
  }

  focusOption(offset: 1 | -1) {
    const items = this.menuItemComponents.toArray();
    const focusedIndex = items.findIndex(menuItem => menuItem.focused);
    const newFocusedIndex = focusedIndex + offset;
    const item = items[newFocusedIndex];
    if (item) {
      item.focus();
    }
  }

  MenuAnchor = MenuAnchor;

  constructor(private readonly cdr: ChangeDetectorRef) {}
}
